/* ============================================================
   CAIROS · comportamiento
   Sin dependencias. Todo se apaga con prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  // Cada seccion pide el script; el navegador lo ejecuta una vez por etiqueta.
  // Este cerrojo evita listeners duplicados.
  if (window.__cairosListo) return;
  window.__cairosListo = true;

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. aparicion al bajar + barras que crecen ---------- */
  function observar() {
    var objetivos = document.querySelectorAll('.cx-revela:not(.cx-visto), .cx-barras:not(.cx-visto)');
    if (!objetivos.length) return;
    if (quieto || !('IntersectionObserver' in window)) {
      objetivos.forEach(function (n) { n.classList.add('cx-visto'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('cx-visto');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    objetivos.forEach(function (n) { io.observe(n); });
  }

  /* ---------- 2. galeria de la ficha ---------- */
  function galeria(raiz) {
    var principal = raiz.querySelector('[data-cx-principal]');
    var tiras = raiz.querySelectorAll('[data-cx-tira]');
    if (!principal || !tiras.length) return;
    tiras.forEach(function (t) {
      t.addEventListener('click', function () {
        principal.src = t.dataset.cxTira;
        principal.srcset = '';
        tiras.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- 3. anadir a la cesta desde el listado ---------- */
  function anadirRapido(boton) {
    var id = boton.dataset.cxAnadir;
    if (!id) return;
    var original = boton.textContent;
    boton.disabled = true;
    boton.textContent = 'Añadiendo...';
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        boton.textContent = 'Añadido';
        abrirCarrito();
        setTimeout(function () { boton.textContent = original; boton.disabled = false; }, 1600);
      })
      .catch(function () {
        boton.textContent = 'No se pudo';
        setTimeout(function () { boton.textContent = original; boton.disabled = false; }, 1800);
      });
  }

  function abrirCarrito() {
    var cajon = document.querySelector('cart-drawer');
    if (cajon && typeof cajon.open === 'function') {
      // Dawn repinta el cajon a partir de sus secciones
      fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (datos) {
          var tmp = document.createElement('div');
          tmp.innerHTML = datos['cart-drawer'];
          var nuevo = tmp.querySelector('cart-drawer');
          var actual = document.querySelector('cart-drawer');
          if (nuevo && actual) {
            actual.classList.remove('is-empty');
            actual.innerHTML = nuevo.innerHTML;
          }
          var burbuja = document.getElementById('cart-icon-bubble');
          if (burbuja && datos['cart-icon-bubble']) {
            var t2 = document.createElement('div');
            t2.innerHTML = datos['cart-icon-bubble'];
            var nb = t2.querySelector('#cart-icon-bubble');
            if (nb) burbuja.innerHTML = nb.innerHTML;
          }
          cajon.open();
        })
        .catch(function () { window.location.href = '/cart'; });
    } else {
      window.location.href = '/cart';
    }
  }

  /* ---------- 3 bis. formulario de la ficha (producto + muestra) ---------- */
  function formularioCompra(form) {
    form.addEventListener('submit', function (ev) {
      var idPrincipal = form.querySelector('input[name="id"]');
      if (!idPrincipal) return;
      ev.preventDefault();

      var campoCantidad = form.querySelector('input[name="quantity"]');
      var cuantos = Math.max(1, Number(campoCantidad && campoCantidad.value) || 1);

      var articulos = [{ id: Number(idPrincipal.value), quantity: cuantos }];
      var muestra = form.querySelector('[data-cx-muestra]');
      if (muestra && muestra.checked) {
        articulos.push({ id: Number(muestra.dataset.cxMuestra), quantity: 1 });
      }

      // "Comprar ahora" lleva directo al pago; "Anadir al carrito" abre el cajon
      var alPago = ev.submitter && ev.submitter.hasAttribute('data-cx-comprar-ya');

      var boton = ev.submitter || form.querySelector('button[type="submit"]');
      var original = boton ? boton.innerHTML : '';
      if (boton) { boton.disabled = true; boton.textContent = 'Añadiendo...'; }

      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: articulos })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () {
          if (alPago) { window.location.href = '/checkout'; return; }
          if (boton) { boton.innerHTML = original; boton.disabled = false; }
          abrirCarrito();
        })
        .catch(function () {
          if (boton) { boton.textContent = 'No se pudo añadir'; }
          setTimeout(function () {
            if (boton) { boton.innerHTML = original; boton.disabled = false; }
          }, 1800);
        });
    });
  }

  /* ---------- 3 quater. selector de cantidad ---------- */
  function cantidad(caja) {
    var campo = caja.querySelector('.cx-cantidad__valor');
    if (!campo) return;
    var menos = caja.querySelector('[data-cx-menos]');
    var mas = caja.querySelector('[data-cx-mas]');
    var tope = Number(campo.getAttribute('max')) || 99;

    function ajustar(paso) {
      var n = Number(campo.value) || 1;
      n = Math.min(tope, Math.max(1, n + paso));
      campo.value = n;
      if (menos) menos.disabled = n <= 1;
      if (mas) mas.disabled = n >= tope;
    }
    if (menos) menos.addEventListener('click', function () { ajustar(-1); });
    if (mas) mas.addEventListener('click', function () { ajustar(1); });
    campo.addEventListener('change', function () { ajustar(0); });
    ajustar(0);
  }

  /* ---------- 3 quinquies. barra fija de compra ---------- */
  function barraFija(barra) {
    var form = document.querySelector('.cx-form-compra');
    var botonReal = form && form.querySelector('button[type="submit"]');
    if (!botonReal) return;

    var boton = barra.querySelector('[data-cx-fija-comprar]');
    if (boton) {
      boton.addEventListener('click', function () {
        // si el boton de verdad esta en pantalla, llevamos al usuario a el;
        // si no, disparamos la compra directamente
        var r = botonReal.getBoundingClientRect();
        if (r.top > 0 && r.bottom < window.innerHeight) {
          botonReal.click();
        } else {
          botonReal.scrollIntoView({ block: 'center', behavior: quieto ? 'auto' : 'smooth' });
          setTimeout(function () { botonReal.click(); }, quieto ? 0 : 420);
        }
      });
    }

    barra.hidden = false;

    // La barra sale cuando el boton de verdad ya no se ve. Lo medimos al
    // hacer scroll en vez de con IntersectionObserver: es igual de barato y
    // funciona tambien cuando el navegador no esta pintando (vistas previas,
    // pestanas en segundo plano, capturas automaticas).
    var reloj = null;
    function revisar() {
      reloj = null;
      var r = botonReal.getBoundingClientRect();
      var alto = window.innerHeight || document.documentElement.clientHeight || 0;
      var fuera = r.bottom < 0 || r.top > alto;
      barra.classList.toggle('cx-visible', fuera);
    }
    function alMover() {
      if (reloj) return;
      reloj = setTimeout(revisar, 80);
    }

    window.addEventListener('scroll', alMover, { passive: true });
    window.addEventListener('resize', alMover, { passive: true });
    revisar();
  }

  /* ---------- 3 ter. carrusel de opiniones ---------- */
  function carrusel(raiz) {
    var pista = raiz.querySelector('[data-cx-pista]');
    if (!pista) return;
    var atras = raiz.querySelector('[data-cx-atras]');
    var adelante = raiz.querySelector('[data-cx-adelante]');

    function paso() {
      var primera = pista.firstElementChild;
      if (!primera) return 300;
      var estilo = window.getComputedStyle(pista);
      var hueco = parseFloat(estilo.columnGap || estilo.gap || '14') || 14;
      return primera.getBoundingClientRect().width + hueco;
    }
    function mover(signo) {
      pista.scrollBy({ left: signo * paso(), behavior: quieto ? 'auto' : 'smooth' });
    }
    function pintarFlechas() {
      if (!atras || !adelante) return;
      var margen = 4;
      atras.disabled = pista.scrollLeft <= margen;
      adelante.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - margen;
      atras.style.opacity = atras.disabled ? '.4' : '1';
      adelante.style.opacity = adelante.disabled ? '.4' : '1';
    }

    if (atras) atras.addEventListener('click', function () { mover(-1); });
    if (adelante) adelante.addEventListener('click', function () { mover(1); });
    pista.addEventListener('scroll', pintarFlechas, { passive: true });
    pintarFlechas();
  }

  /* ---------- 4. el asesor de cuatro preguntas ---------- */
  function asesor(raiz) {
    var fuente = raiz.querySelector('[data-cx-productos]');
    if (!fuente) return;
    var productos = [];
    try { productos = JSON.parse(fuente.textContent) || []; } catch (e) { productos = []; }

    var pantallas = Array.prototype.slice.call(raiz.querySelectorAll('.cx-asesor__pantalla'));
    var pasos = Array.prototype.slice.call(raiz.querySelectorAll('.cx-asesor__paso'));
    var salida = raiz.querySelector('[data-cx-resultado]');
    var respuestas = {};
    var indice = 0;

    function mostrar(i) {
      indice = Math.max(0, Math.min(i, pantallas.length - 1));
      pantallas.forEach(function (p, n) { p.classList.toggle('cx-activo', n === indice); });
      pasos.forEach(function (p, n) { p.classList.toggle('cx-activo', n <= indice); });
      if (indice === pantallas.length - 1) pintar();
    }

    function puntuar(p) {
      var t = p.tags || [];
      var puntos = 0;
      if (respuestas.genero) {
        if (t.indexOf(respuestas.genero) > -1) puntos += 4;
        else if (t.indexOf('unisex') > -1) puntos += 2;
      }
      if (respuestas.familia) {
        respuestas.familia.split(',').forEach(function (f) { if (t.indexOf(f) > -1) puntos += 3; });
      }
      if (respuestas.ocasion) {
        if (t.indexOf(respuestas.ocasion) > -1) puntos += 2;
      }
      if (respuestas.estela) {
        var quiero = Number(respuestas.estela);
        var suya = Number(p.estela || 3);
        puntos += 3 - Math.min(3, Math.abs(quiero - suya));
      }
      return puntos;
    }

    function pintar() {
      if (!salida) return;
      var lista = productos.slice().map(function (p) { return { p: p, n: puntuar(p) }; });
      lista.sort(function (a, b) { return b.n - a.n; });
      var tres = lista.slice(0, 3).filter(function (x) { return x.n > 0; });
      if (!tres.length) {
        salida.innerHTML = '<p class="cx-asesor__vacio">Con esa combinacion no tengo nada exacto en casa. Escribeme por WhatsApp y te digo que te pega de lo que puedo traer.</p>';
        return;
      }
      salida.innerHTML = tres.map(function (x, i) {
        var p = x.p;
        return '<article class="cx-tarjeta">' +
          '<a class="cx-tarjeta__enlace" href="' + p.url + '" aria-label="' + p.titulo + '"></a>' +
          (i === 0 ? '<span class="cx-tarjeta__sello">Tu firma</span>' : '') +
          '<span class="cx-tarjeta__media">' + (p.img ? '<img src="' + p.img + '" alt="' + p.titulo + '" loading="lazy" width="400" height="500">' : '') + '</span>' +
          '<div class="cx-tarjeta__cuerpo">' +
          '<span class="cx-tarjeta__casa">' + (p.casa || '') + '</span>' +
          '<h3 class="cx-tarjeta__nombre">' + p.titulo + '</h3>' +
          '<p class="cx-tarjeta__caracter">' + (p.caracter || '') + '</p>' +
          '<div class="cx-tarjeta__pie"><span class="cx-tarjeta__precio">' + p.precio + '</span>' +
          '<span class="cx-tarjeta__anadir">Ver ficha</span></div>' +
          '</div></article>';
      }).join('');
    }

    raiz.addEventListener('click', function (ev) {
      var op = ev.target.closest('[data-cx-clave]');
      if (op && raiz.contains(op)) {
        respuestas[op.dataset.cxClave] = op.dataset.cxValor;
        mostrar(indice + 1);
        return;
      }
      var atras = ev.target.closest('[data-cx-atras]');
      if (atras && raiz.contains(atras)) mostrar(indice - 1);
      var otra = ev.target.closest('[data-cx-reiniciar]');
      if (otra && raiz.contains(otra)) { respuestas = {}; mostrar(0); }
    });

    mostrar(0);
  }

  /* ---------- arranque ---------- */
  function iniciar() {
    observar();
    document.querySelectorAll('[data-cx-galeria]').forEach(galeria);
    document.querySelectorAll('[data-cx-asesor]').forEach(asesor);
    document.querySelectorAll('.cx-form-compra').forEach(formularioCompra);
    document.querySelectorAll('[data-cx-carrusel]').forEach(carrusel);
    document.querySelectorAll('[data-cx-cantidad]').forEach(cantidad);
    document.querySelectorAll('[data-cx-fija]').forEach(barraFija);
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-cx-anadir]');
      if (b) { ev.preventDefault(); anadirRapido(b); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }

  // el editor de temas vuelve a montar secciones sueltas
  document.addEventListener('shopify:section:load', function (e) {
    observar();
    e.target.querySelectorAll('[data-cx-galeria]').forEach(galeria);
    e.target.querySelectorAll('[data-cx-asesor]').forEach(asesor);
    e.target.querySelectorAll('.cx-form-compra').forEach(formularioCompra);
    e.target.querySelectorAll('[data-cx-carrusel]').forEach(carrusel);
    e.target.querySelectorAll('[data-cx-cantidad]').forEach(cantidad);
    e.target.querySelectorAll('[data-cx-fija]').forEach(barraFija);
  });
})();
